import { Component, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoDirective } from '@jsverse/transloco';
import { ThemeService, ThemeMode } from '../../service/theme.service';

@Component({
  selector: 'app-theme-switcher',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    TranslocoDirective
  ],
  template: `
    <div *transloco="let t">
      <button
        mat-icon-button
        [matMenuTriggerFor]="themeMenu"
        [matTooltip]="t('THEME.TOOLTIP')"
        class="mat-app-button-secondary">
        <mat-icon>{{ getCurrentThemeIcon() }}</mat-icon>
      </button>

      <mat-menu #themeMenu="matMenu" class="theme-menu">
        <button
          *ngFor="let option of themeOptions"
          mat-menu-item
          (click)="setTheme(option.value)"
          [class.active]="themeService.currentTheme() === option.value"
          class="mat-app-text-primary">
          <mat-icon class="mr-3">{{ option.icon }}</mat-icon>
          <span>{{ t(option.label) }}</span>
          <mat-icon
            *ngIf="themeService.currentTheme() === option.value"
            class="ml-auto mat-app-primary-color">
            check
          </mat-icon>
        </button>
      </mat-menu>
    </div>
  `
})
export class ThemeSwitcherComponent {
  themeService = inject(ThemeService);

  themeOptions: {value: ThemeMode, label: string, icon: string}[];

  constructor() {
    this.themeOptions = this.themeService.getThemeOptions();
  }

  setTheme(theme: ThemeMode): void {
    this.themeService.setTheme(theme);
  }

  getCurrentThemeIcon(): string {
    const theme = this.themeService.currentTheme();
    const isDark = this.themeService.isDark();

    switch (theme) {
      case 'light':
        return 'light_mode';
      case 'dark':
        return 'dark_mode';
      case 'system':
        return isDark ? 'dark_mode' : 'light_mode';
      default:
        return 'settings_brightness';
    }
  }
}
